module.exports = __webpack_public_path__ + "static/media/table-4.f46e0d86.webp";